import * as R from 'ramda';
import { message } from 'antd';

import {
  fetchAttachments,
  removeAttachment,
  createAttachments,
} from '../../api/apiko-api/';
import { getResErrorMsg } from '../../utils';
import * as actions from '../actions/attachments';
import { updateRequestSuccess } from '../actions/requests';
import { updateCompanySuccess } from '../actions/companies';


const updateRequestCompanyData = (files = [], dispatch, getState) => {
  const [{ companyId, requestId } = {}] = files;

  const allFilesIds = files.map(({ _id }) => _id);

  if (companyId) {
    // get Company from state
    const company = R.pathOr({}, ['companies', 'items', companyId], getState());
    const updateCompanyData = {
      ...company,
      attachments: [...R.pathOr([], ['attachments'], company), ...allFilesIds],
    };

    // update Company's Attachments
    dispatch(updateCompanySuccess(updateCompanyData));
  }

  if (requestId) {
    // get Request from state
    const request = R.pathOr({}, ['requests', 'items', requestId], getState());
    const modifier = {
      ...request,
      attachments: [...R.pathOr([], ['attachments'], request), ...allFilesIds],
    };

    // update Request's Attachments
    dispatch(updateRequestSuccess({ requestId, modifier }));
  }
};


/**
 * handleAttachmentsFetch :: Object -> Func -> Promise Error _
 */
export const handleAttachmentsFetch = data => (dispatch, getState) =>
  Promise.resolve(dispatch(actions.fetchAttachmentsRequest()))
    .then(() => fetchAttachments(data))
    .then((files) => {
      updateRequestCompanyData(files, dispatch, getState);

      dispatch(actions.fetchAttachmentsSuccess(files));
    })
    .catch((error) => {
      message.error(`Failed to fetch attachments: ${getResErrorMsg(error)}`);
      dispatch(actions.fetchAttachmentsFailure(error));
    });


/**
 * handleAttachmentsCreate :: Object -> (Func, Func) -> Promise Error _
 */
export const handleAttachmentsCreate = formData => (dispatch, getState) =>
  Promise.resolve(dispatch(actions.createAttachmentsRequest()))
    .then(() => createAttachments(formData))
    .then((files) => {
      updateRequestCompanyData(files, dispatch, getState);

      dispatch(actions.createAttachmentsSuccess(files));
    })
    .catch((error) => {
      message.error(`Failed to upload attachment(s): ${getResErrorMsg(error)}`);
      dispatch(actions.createAttachmentsFailure(error));
    });


/**
 * handleAttachmentsRemove :: String -> (Func, Func) -> Promise Error _
 */
export const handleAttachmentsRemove = attachmentId => (dispatch, getState) =>
  Promise.resolve(dispatch(actions.removeAttachmentRequest()))
    .then(() => removeAttachment(attachmentId))
    .then((attachment) => {
      const { companyId, requestId, _id } = attachment;

      if (companyId) {
        // get Company from state
        const company = R.pathOr({}, ['companies', 'items', companyId], getState());
        const updateCompanyData = {
          ...company,
          attachments: R.without(_id, company.attachments),
        };

        // update Company's Attachments
        dispatch(updateCompanySuccess(updateCompanyData));
      }

      if (requestId) {
        // get Request from state
        const request = R.pathOr({}, ['requests', 'items', requestId], getState());
        const modifier = {
          ...request,
          attachments: R.without(_id, request.attachments),
        };

        // update Request's Attachments
        dispatch(updateRequestSuccess({ requestId, modifier }));
      }

      dispatch(actions.removeAttachmentSuccess(attachment));
    })
    .catch((error) => {
      message.error(`Failed to remove attachment: ${getResErrorMsg(error)}`);
      dispatch(actions.removeAttachmentFailure(error));
    });



// WEBPACK FOOTER //
// ./src/redux/thunk/attachments.js